(function () {
  const DRAWER_SECTION_ID = 'lcf-cart-drawer';
  const HEADER_SECTION_ID = 'lcf-header';

  let drawerOpen = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function applyDrawerOpenState() {
    const drawer = $('[data-lcf-cart-drawer]');
    const overlay = $('[data-lcf-drawer-overlay]');
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function openDrawer() {
    drawerOpen = true;
    applyDrawerOpenState();
  }

  function closeDrawer() {
    const drawer = $('[data-lcf-cart-drawer]');
    const overlay = $('[data-lcf-drawer-overlay]');
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    drawerOpen = false;
  }

  function updateCartCount(count) {
    $$('[data-lcf-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  async function refreshSections(ids) {
    const param = 'sections=' + ids.map(encodeURIComponent).join(',');
    const res = await fetch('/?' + param, { headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    return await res.json();
  }

  function replaceSection(id, html) {
    if (!html) return;
    const tmpl = document.createElement('template');
    tmpl.innerHTML = html.trim();
    const existing = document.getElementById('shopify-section-' + id);
    if (existing && tmpl.content.firstElementChild) {
      existing.replaceWith(tmpl.content.firstElementChild);
    }
  }

  async function refreshCartUI() {
    const data = await refreshSections([DRAWER_SECTION_ID, HEADER_SECTION_ID]);
    if (data) {
      if (data[DRAWER_SECTION_ID]) replaceSection(DRAWER_SECTION_ID, data[DRAWER_SECTION_ID]);
      if (data[HEADER_SECTION_ID]) replaceSection(HEADER_SECTION_ID, data[HEADER_SECTION_ID]);
      bindCartUI();
    }
    if (drawerOpen) applyDrawerOpenState();
    try {
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
      }
    } catch (e) {}
  }

  function showToast(message) {
    let toast = $('[data-lcf-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lcf-toast';
      toast.setAttribute('data-lcf-toast', '');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    const tick = document.createElement('span');
    tick.textContent = '✓';
    tick.style.fontWeight = '700';
    toast.appendChild(tick);
    const span = document.createElement('span');
    span.textContent = message;
    toast.appendChild(span);
    toast.classList.add('is-open');
    clearTimeout(toast._lcfTimer);
    toast._lcfTimer = setTimeout(function () { toast.classList.remove('is-open'); }, 2400);
  }

  async function addToCart(variantId, quantity, productTitle) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
      });
      const data = await res.json();
      if (!res.ok) {
        showToast(data && data.description ? data.description : 'Could not add to bag');
        return;
      }
      await refreshCartUI();
      showToast((productTitle || data.product_title || 'Item') + ' added to your bag');
      openDrawer();
    } catch (e) {
      showToast('Could not add to bag');
    }
  }

  async function changeLineQuantity(lineKey, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity)) })
      });
      if (!res.ok) return;
      await refreshCartUI();
    } catch (e) {}
  }

  function bindCartUI() {
    $$('[data-lcf-cart-open]').forEach(function (el) {
      if (el._lcfBound) return;
      el._lcfBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    $$('[data-lcf-drawer-close]').forEach(function (el) {
      if (el._lcfBound) return;
      el._lcfBound = true;
      el.addEventListener('click', closeDrawer);
    });
    $$('[data-lcf-drawer-overlay]').forEach(function (el) {
      if (el._lcfBound) return;
      el._lcfBound = true;
      el.addEventListener('click', closeDrawer);
    });

    $$('[data-lcf-cart-line]').forEach(function (line) {
      if (line._lcfBound) return;
      line._lcfBound = true;
      const key = line.dataset.lineKey;
      const qtyValue = line.querySelector('[data-lcf-cart-line-qty-value]') || line.querySelector('[data-lcf-line-qty-value]');
      line.querySelectorAll('[data-lcf-line-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const step = parseInt(btn.dataset.lcfLineQty, 10) || 0;
          const current = parseInt((qtyValue && qtyValue.textContent) || '1', 10) || 1;
          changeLineQuantity(key, current + step);
        });
      });
    });
  }

  function bindAddButtons() {
    document.addEventListener('click', function (e) {
      const addEl = e.target.closest('[data-lcf-product-add]');
      if (addEl) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = addEl.dataset.lcfProductAdd;
        const card = addEl.closest('.lcf-product-card');
        const title = card ? (card.querySelector('.lcf-product-card__title') || {}).textContent : '';
        addToCart(variantId, 1, title);
      }
      const pdpAdd = e.target.closest('[data-lcf-pdp-add]');
      if (pdpAdd) {
        e.preventDefault();
        const form = pdpAdd.closest('form');
        if (!form) return;
        const variantInput = form.querySelector('[data-lcf-variant-id]');
        const qtyInput = form.querySelector('input[name="quantity"]');
        const titleEl = $('.lcf-pdp__title');
        const variantId = variantInput ? variantInput.value : '';
        const qty = qtyInput ? qtyInput.value : 1;
        const title = titleEl ? titleEl.textContent : '';
        addToCart(variantId, qty, title);
      }
    });
  }

  function init() {
    bindCartUI();
    bindAddButtons();
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
